/**
 * Utility functions for jobsite operations
 */

/**
 * Maps jobsite completion status to percentage
 * Based on backend JobCompletionStatus lookup table values
 *
 * @param status - The completion status from jobCompletionStatus.status field
 * @returns Percentage value (0-100) representing completion
 *
 * @example
 * getJobsiteCompletionPercentage('start') // returns 0
 * getJobsiteCompletionPercentage('Finish work') // returns 80
 * getJobsiteCompletionPercentage('Project Completed') // returns 100
 */
export const getJobsiteCompletionPercentage = (status: string | null | undefined): number => {
  if (!status) return 0;

  const normalizedStatus = status.trim();

  const statusMap: Record<string, number> = {
    'Pre-construction': 0,
    'Site Services': 20,
    'Building Shell': 40,
    'Rough-in': 60,
    'Finish Work': 80,
    'Project Completed': 100
  };

  return statusMap[normalizedStatus] ?? 0;
};
